// extracted by mini-css-extract-plugin
export default {"contactSmall":"uOlOAVKk7Qn7IEDtCPe6","label":"RnnKEn6mdz1v_OwzFrAr","info":"FP7oc2PrrMxAzcwA5dM8"};